import React, { Component } from 'react'
import { Modal} from 'antd'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import Notification from '../Notification'
import PropagateLoader from '../SubmitingForm'
import ajax from '../../utils/ajax'
import functions from '../../utils/functions'


class AddSpecialityCategory extends Component {
  state = {
    userId: functions.sessionGuard(),
    specialityName:"",
    categoryCode:"",
    load:""
  }

  handleCancel = () => {
    const sent = this.props
    this.setState({ visible: false })
    sent.handleCancel(false)
  }


  specialityName = (value)=> {
    this.setState({ specialityName: value.target.value })
  }
  categoryCode = (value)=> {
    this.setState({ categoryCode: value.target.value })
  }


  onPressAddCategory= async (event)=>{
    event.preventDefault()
    const { specialityName,categoryCode} = this.state

    if (specialityName.length > 0 && 
      categoryCode.length >0 ) {
        this.setState({
          type: '',
          info: '',
          load:<PropagateLoader/>
        })

          //fetch category from the API
          const server_response = await ajax.createSpecialityCategory(specialityName, categoryCode,this.state.userId)

          if (server_response.status === "OK") {
            this.setState({
              type: 'alert alert-success',
              info: server_response.details.message,
              load: '',
            })
            window.location.reload()

        } else {

          this.setState({
            type: 'alert alert-danger',
            info: server_response.details.message,
            load: '',
          })

        }


      }else{
        this.setState({
          type: 'alert alert-danger',
          info: 'Please be advised to fill in all required fields - All fields are required',
          load:'',
        })
      }
  }


  render() {
    return (

        <Modal
        title = {"ADD SPECIALITY CATEGORY"}
        centered
        bodyStyle={{ paddingBottom: '0px', paddingTop: '0px' }}
        visible={this.props.visible.visible}
        maskClosable={false}
        footer={[null]}
        maskTransitionName=""
        onCancel={this.handleCancel}
        width={700}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: false }}
      >

<br/>
<div class="row">
<div class="col-sm-12 mobile-inputs">

{this.state.load}
  <Notification
        message={{
          type: this.state.type,
          info: this.state.info,
        }}
    />

<form method="post" onSubmit={this.onPressAddCategory}>
<div class="form-group row">
<div class="col-sm-6">
<input type="text" onChange={this.specialityName} class="form-control form-txt-primary" placeholder="Speciality Category Name"/>
</div>
<div class="col-sm-6">
<input type="text" onChange={this.categoryCode} class="form-control form-txt-primary" placeholder="Specialty Category Code"/>
</div>
</div>

<div class="form-group row">
<div class="col-sm-6">
</div>

</div>
<div class="row">
<div class="col-sm-4 card-header-right" >
<button type="submit" class="btn btn-primary btn-block mb-3">Add Speciality Category</button>
 </div>
 </div>
</form>
</div>
</div>


     
      </Modal>

    )}}

    export default AddSpecialityCategory